import { defineMessages } from 'react-intl';

export default defineMessages({
  EmptyOption: {
    id: 'FilterLabels.EmptyOption',
    defaultMessage: '- Select -',
  },
  Search: {
    id: 'FilterLabels.Search',
    defaultMessage: 'Search',
  },
  JobCategory: {
    id: 'FilterLabels.JobCategory',
    defaultMessage: 'Job Category',
  },
  Region: {
    id: 'FilterLabels.Region',
    defaultMessage: 'Region',
  },
  Country: {
    id: 'FilterLabels.Country',
    defaultMessage: 'Location',
  },
  States: {
    id: 'FilterLabels.States',
    defaultMessage: 'State',
  },
  Location: {
    id: 'FilterLabels.Location',
    defaultMessage: 'City',
  },
  Reset: {
    id: 'FilterLabels.Reset',
    defaultMessage: 'Reset Filters',
  },
  TypeLabel: {
    id: 'FilterLabels.Type',
    defaultMessage: 'Job Type',
  },
  TypeFullTime: {
    id: 'FilterLabels.Types.FullTime',
    defaultMessage: 'Full-Time',
  },
  TypePartTime: {
    id: 'FilterLabels.Types.PartTime',
    defaultMessage: 'Part-Time',
  },
  TypeIntern: {
    id: 'FilterLabels.Types.Intern',
    defaultMessage: 'Intern/Apprentice',
  },
  TypeSeasonal: {
    id: 'FilterLabels.Types.Seasonal',
    defaultMessage: 'Seasonal',
  },
});
